class LazyLoading {
    constructor({
    selector = '.lazy-image',
    rootMargin = '500px 500px',
    threshold = 0.01,
  } = {}) {
    this.selector = selector;
    this.rootMargin = rootMargin;
    this.threshold = threshold;

    this.images = document.querySelectorAll(this.selector);

    this.init();
  }

  init() {
    if (!('IntersectionObserver' in window)) {
      this.loadAll();
      return;
    }

    this.observer = new IntersectionObserver(
      this.onIntersection.bind(this),
      {
        rootMargin: this.rootMargin,
        threshold: this.threshold,
      }
    );

    this.images.forEach((img) => {
        this.optimizeLoadImages(img);
    });
  }

  onIntersection(entries) {    
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;        
      const img = entry.target;
      this.loadImage(img);

      this.observer.unobserve(img);
    });
  }

  loadImage(img) {
    const parentElem = img.parentNode;
    if(parentElem.querySelectorAll(".loading-product-img").length == 0)
    {
      const loading = document.createElement("span");
      loading.classList.add("loading-product-img");
      loading.innerHTML = `<div class="skeleton-card">
                            <div class="skeleton skeleton-img"></div>
                          </div>`;
      parentElem.appendChild(loading);
    }
    if (img.dataset.src) img._fullSrc = img.dataset.src;
    const src = this.sizedSrc(img, img.dataset.src);
    const srcset = this.sizedSrc(img, img.dataset.srcset);

    if (src) img.src = src;
    if (srcset) img.srcset = srcset;

    img.onload = () => {
      const parentElem = img.parentNode;
      if(parentElem.querySelectorAll(".loading-product-img").length > 0)
      {
        parentElem.querySelector(".loading-product-img").remove();
      }
      img.classList.add('loaded');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    };
  }

  // Mobile only: ask the CDN for the image at the card container's width +30%
  // (against softness) instead of the snippet's size (usually 940x). Desktop
  // keeps the original URL.
  sizedSrc(img, url) {
    if (!url || !window.matchMedia('(max-width: 749px)').matches) return url;
    const match = url.match(/_(\d+)x(?=\.[a-z0-9]+(\?|$))/i);
    if (!match) return url;
    const target = this.mobileTargetWidth(img);
    if (!target) return url;
    const original = parseInt(match[1], 10);
    const width = Math.min(target, original);
    img.dataset.mobileWidth = width;
    return width === original ? url : url.replace(match[0], '_' + width + 'x');
  }

  // Measured once per view (all cards in the grid share a width) using the
  // layout width, which ignores entry animations / transforms.
  mobileTargetWidth(img) {
    if (!this._mobileTarget) {
      const box = img.closest('.card-media') || img.parentNode;
      const cssWidth = box ? box.offsetWidth : 0;
      if (!cssWidth) return 0;
      this._mobileTarget = Math.ceil(cssWidth * 2);
    }
    return this._mobileTarget;
  }

  // After the mobile grid/list toggle: re-request any image whose card is now
  // wider than the size it was loaded at. Never downsizes.
  resizeLoaded() {
    this._mobileTarget = 0;
    document.querySelectorAll(this.selector + '[data-mobile-width]').forEach((img) => {
      if (!img._fullSrc) return;
      const before = parseInt(img.dataset.mobileWidth, 10);
      const url = this.sizedSrc(img, img._fullSrc);
      if (parseInt(img.dataset.mobileWidth, 10) > before) {
        img.srcset = url;
        img.src = url;
      } else {
        img.dataset.mobileWidth = before;
      }
    });
  }

  loadAll() {
    document.querySelectorAll(this.selector).forEach((img) =>
      {
        this.optimizeLoadImages(img);
      }
    );
  }

  refresh() {
    this.images = document.querySelectorAll(this.selector);
    this.images.forEach((img) => {
      this.optimizeLoadImages(img);
    });
  }

  optimizeLoadImages(img){
    // Card slider: only the first slide is observed; product-card-slider.js
    // loads the others when the user swipes / clicks an arrow or dot.
    const slide = img.closest('.pcs-slide');
    if (slide && slide !== slide.parentNode.firstElementChild) return;

    const parent = img.parentNode;
    const index = Array.from(parent.children).indexOf(img);
    if(!img.classList.contains("loaded") && typeof img.observeIntraction == "undefined")
    {
      img.observeIntraction = true;
      // console.log(index);
      if(index == 0)
      {
        this.observer.observe(img);
      }
      else 
      {
        // console.log("here!!");
        
        const parentElem = parent.closest(".card");
        parentElem.childElement = img;
        const thisObj = this;
        parentElem.onmouseover = parentElem.onclick = null;
        parentElem.ontouchstart = parentElem.onmouseover = parentElem.onclick = function (e) {
          // console.log("hover!!!");          
          if(!parentElem.childElement.classList.contains("loaded"))
          {
              thisObj.loadImage(this.childElement);
          }
          this.ontouchstart = this.onmouseover = this.onclick = null;
        }
      }
    }
  }

}

document.addEventListener('shopify:section:load', () => {
    window.plpLazy?.refresh();
});
window.domContentLoadFunc(()=>{

  window.plpLazy = new LazyLoading();
});